import { LoanPurpose } from "../../lead-api";
import { type LoanPurposeTypeMenuItem } from "../LoanPurposeType.types";

export const loanPurposeTypeMenuItems: LoanPurposeTypeMenuItem[] = [
  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.EstablishingCreditHistory}`,
    value: LoanPurpose.EstablishingCreditHistory,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.HomeMaintenanceAndImprovement}`,
    value: LoanPurpose.HomeMaintenanceAndImprovement,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.MedicalExpenses}`,
    value: LoanPurpose.MedicalExpenses,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.BusinessExpenses}`,
    value: LoanPurpose.BusinessExpenses,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.LoanPaymentOrConsolidation}`,
    value: LoanPurpose.LoanPaymentOrConsolidation,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.PaymentForServices}`,
    value: LoanPurpose.PaymentForServices,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.ElectronicsPurchase}`,
    value: LoanPurpose.ElectronicsPurchase,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.GroceriesAndDailyExpenses}`,
    value: LoanPurpose.GroceriesAndDailyExpenses,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.EducationExpenses}`,
    value: LoanPurpose.EducationExpenses,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.Travel}`,
    value: LoanPurpose.Travel,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.EmergencyOrUnexpectedExpenses}`,
    value: LoanPurpose.EmergencyOrUnexpectedExpenses,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.VehiclePurchase}`,
    value: LoanPurpose.VehiclePurchase,
  },

  {
    label: `inputs.loan_info.loan_purpose_type.options.${LoanPurpose.Other}`,
    value: LoanPurpose.Other,
  },
];
